<template>
  <v-card
    class="px-4 py-3 d-flex align-center"
    elevation="0"
    @click="handleClick"
  >
    <UserAvatar
      size="36px"
      fontSize="12px"
      :account="user"
      :imageSize="IMAGE_SIZES.MINI"
    />
    <div class="ms-2">
      <span class="subtitle2 blue-grey--text text--darken-2">
        {{ user.name }}
      </span>
      <p class="subtitle2 blue-grey--text text--darken-1 mb-0">
        {{ user.total }} {{ entityLabel }}
      </p>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import UserAvatar from '@/components/UserAvatar.vue'

import mixin from '@/mixins/mixin.vue'
import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  name: 'UserItem',

  mixins: [mixin],

  components: {
    UserAvatar,
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),

    entityLabel() {
      if (this.type === 0) {
        return this.$t(
          'home.activity_board.top_users.top_users_by_completed_revs_label'
        )
      } else if (this.type === 1) {
        return this.$t(
          'home.activity_board.top_users.top_users_by_executed_routines_label'
        )
      } else {
        return ''
      }
    },
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },

  methods: {
    handleClick() {
      return this.navigateTo({
        name: 'profile',
        params: {
          organizationId: this.organizationId,
          userId: this.user.id,
        },
      })
    },
  },
}
</script>
